import { useTranslation } from 'react-i18next';
import { Box, BoxProps, Text } from '/src/components';
import { pxToPt } from '/src/utils';

export const IncentiveStatementDescription: React.FC<IncentiveStatementDescriptionProps> = (props) => {
  const { ...boxProps } = props;
  const { t } = useTranslation();

  return (
    <Box width="50%" pad={{ right: pxToPt('6px') }} {...boxProps}>
      <Text size={pxToPt('11px')}>{t('statements:incentiveStatementNotice')}</Text>
    </Box>
  );
};

export type IncentiveStatementDescriptionProps = BoxProps;
